const TOGGLE_MODAL = "TOGGLE_MODAL";
const IS_SIGNING_OUT = "IS_SIGNING_OUT";
const SAVE_SETTINGS = "SAVE_SETTINGS";

export { 
    TOGGLE_MODAL, 
    IS_SIGNING_OUT, 
    SAVE_SETTINGS };
